import { PasswordResetForm } from "@/components/password-reset-form";
import { useSearchParams } from "react-router-dom";

export default function PasswordResetPage() {
    const [params] = useSearchParams();

    return (
        <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
            <div className="w-full max-w-sm flex flex-col gap-8">
                <img alt="Logo" src="/logo_text.png" />
                <PasswordResetForm
                    code={params.get("code")}
                    email={params.get("email")}
                />
            </div>
        </div>
    );
}
